module.exports = __webpack_public_path__ + "static/media/group-111.be264a96.svg";